<template>
  <div class="container">
    <div class="title">{{ title }}</div>
    <div class="info-wrap">
      <div class="info-left">
        <div class="info-time">{{ time }}</div>
        <div class="info-part">{{ part }}</div>
      </div>
      <div class="info-view">阅读{{ look }}</div>
    </div>
    <div class="content" v-html="content"></div>
    <div class="file-wrap">
      <div
        class="file-list"
        v-for="(item, i) in fileList"
        :key="i"
        @click="fileDownload(item.ossUrl)"
      >
        <van-icon name="orders-o" />
        <div class="file-name">{{ item.fileName }}</div>
      </div>
    </div>
    <div class="footer">
      <div @click="linkTap($event)">我要分享<i></i></div>
    </div>
  </div>
</template>
<script>
import { getDetailById, getShareDetail } from '@api/lishui/notice'
import { Toast } from 'vant'
import Clipboard from 'clipboard' // 复制功能

export default {
  data() {
    return {
      title: '',
      time: '',
      part: '',
      look: 0,
      content: '',
      fileList: []
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      getDetailById({ id: this.$route.query.id }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.title = data.informTitle
          this.time = data.startTime
          this.part = data.creator
          this.look = data.readNum
          this.content = data.content
          this.fileList = data.fileList
        } else {
          Toast(msg)
        }
      })
    },
    // 复制链接
    linkTap(e) {
      const clipboard = new Clipboard(e.target, {
        text: () => window.location.href
      })
      clipboard.on('success', e => {
        Toast('链接复制成功！')
      })
      clipboard.onClick(e), getShareDetail().then(res => {})
    },
    // 文件下载
    fileDownload(url) {
      // 判断安卓还是IOS
      // let ua = navigator.userAgent
      // // let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      // let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(ua)
      // if (isiOS) {
      this.$copyText(url).then(res => {
        Toast('复制链接成功，请前往浏览器打开链接下载文件！')
      })
      // } else {
      //   window.open(url)
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding: 20px 15px;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.info-wrap {
  width: 100%;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  .info-left {
    display: flex;
    align-items: center;
    overflow: hidden;
    .info-time,
    .info-part {
      font-size: 14px;
      color: #666;
      margin-right: 10px;
      white-space: nowrap;
    }
    .info-part {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .info-view {
    font-size: 14px;
    color: #666;
    white-space: nowrap;
  }
}
.content {
  font-size: 15px;
  padding: 15px 0;
  line-height: 0.7rem;
  /deep/p {
    word-wrap: break-word;
  }
}
.file-wrap {
  margin-bottom: 100px;
  .file-list {
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid #ddd;
    margin-bottom: 15px;
    /deep/.van-icon {
      font-size: 15px;
      color: #4e6ef2;
    }
    .file-name {
      font-size: 15px;
      padding-left: 10px;
      color: #4e6ef2;
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
  > div {
    width: 80%;
    height: 41px;
    line-height: 41px;
    color: #fff;
    text-align: center;
    border-radius: 45px;
    font-size: 16px;
    background: linear-gradient(90deg, #0070ff 0%, #0060ff 100%);
    margin: 15px auto;
    letter-spacing: 1px;
    i {
      display: inline-block;
      width: 15px;
      height: 15px;
      background: url('../../../assets/enterprise/share.svg') no-repeat;
      background-size: 100%;
      color: #fff;
      margin-left: 8px;
      vertical-align: middle;
    }
  }
}
</style>
